import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { CurrencySetDefaultCommand, CurrencySetDefaultCommandHandlerBase, CurrencySetDefaultResponse } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(CurrencySetDefaultCommand)
@Injectable({ providedIn: 'root'})
export class CurrencySetDefaultCommandHandler {
    private commandHandler: CurrencySetDefaultCommandHandlerBase;
    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new CurrencySetDefaultCommandHandlerBase(http);
    }

    public async handleAsync(cmd: CurrencySetDefaultCommand): Promise<CurrencySetDefaultResponse> {
        return await this.commandHandler.handleAsync(cmd);
    }
}
